import styled from '@emotion/styled';
import Link from 'presentations/views/components/atoms/Link';
import {
  gray01,
  gray04,
  primary,
  white,
} from 'presentations/views/styles/color';
import { fontWeight, mediaMax, spacing } from 'presentations/views/styles';
import { ReactNode } from 'react';

export interface Props {
  index: number;
  link: string;
  isActive: boolean;
  children: ReactNode;
}

export default function Component(props: Props) {
  return (
    <ToggleLinkButton
      data-tab={props.index}
      href={props.link}
      isActive={props.isActive}
    >
      {props.children}
    </ToggleLinkButton>
  );
}

const ToggleLinkButton = styled(Link)<{ isActive: boolean }>`
  display: inline-flex;
  align-items: center;
  background-color: ${white};
  border-width: 1px;
  border-style: solid;
  border-color: ${(props) => {
    return props.isActive ? primary : gray04;
  }};
  color: ${(props) => {
    return props.isActive ? primary : gray01;
  }};
  border-radius: 18px;
  padding: 0 ${spacing(16)};
  height: 37px;
  font-weight: ${fontWeight('bold')};
  ${mediaMax.tablet} {
    padding: 0 ${spacing(12)};
  }
`;
